import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const RoleBasedRedirect = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // Redirect based on user role
      if (user.role === 'O' || user.role === 'operator') {
        navigate('/operator', { replace: true });
      } else if (user.role === 'S' || user.role === 'supervisor') {
        navigate('/supervisor', { replace: true });
      } else if (user.role === 'M' || user.role === 'manager') {
        navigate('/manager', { replace: true });
      } else {
        // Admin and other roles go to main dashboard
        navigate('/dashboard', { replace: true });
      }
    }
  }, [user, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600 dark:text-gray-400">Loading...</p>
      </div>
    </div>
  );
};

export default RoleBasedRedirect;
